import { z } from 'zod';
import type { BuildingDef } from '../sim/data/types';
import { parseOrThrow } from './validate';

const BuildingFile = z.object({
  id: z.string().min(1),
  role: z.enum([
    'town-center',
    'supply',
    'barracks',
    'lumber',
    'stables',
    'magic',
    'defense',
    'gold-mine',
  ]),
  width: z.number().int().positive(),
  height: z.number().int().positive(),
  dropOff: z.array(z.enum(['gold', 'lumber'])),
  supplyProvided: z.number().int().nonnegative().default(0),
  trains: z.array(z.string().min(1)).default([]),
  cost: z.object({ gold: z.number().int().nonnegative(), lumber: z.number().int().nonnegative() }),
  buildTicks: z.number().int().nonnegative(),
  hp: z.number().int().positive().optional(),
  mine: z.enum(['gold']).optional(),
});

export type BuildingFile = z.infer<typeof BuildingFile>;

export function parseBuildingDef(
  raw: unknown,
  source = 'building file',
): BuildingDef & { role: BuildingFile['role'] } {
  const f = parseOrThrow(BuildingFile, raw, source);
  return {
    id: f.id,
    role: f.role,
    width: f.width,
    height: f.height,
    dropOff: f.dropOff,
    supplyProvided: f.supplyProvided,
    trains: f.trains,
    cost: f.cost,
    buildTicks: f.buildTicks,
    hp: f.hp,
    mine: f.mine,
  };
}
